export default "__VITE_ASSET__1iMUiupi__"